angular.module('Housing').factory('DistrictResource', [
    '$resource',
    $resource =>
        $resource(
            '/api/v1/district/:action/:id',
            {},
            {
                getAll: {
                    method: 'GET',
                    isArray: true,
                    params: {}
                },
                getPaged: {
                    method: 'GET',
                    isArray: false,
                    params: { action: 'paged', page: 0, pageSize: 15 }
                },
                getById: {
                    method: 'GET',
                    isArray: false,
                    params: { id: '@id' }
                },
                delete: {
                    method: 'DELETE',
                    isArray: false,
                    params: { id: '@id' }
                },
                save: {
                    method: 'POST',
                    isArray: false,
                    params: { id: '@id' }
                },
                update: {
                    method: 'PUT',
                    isArray: false,
                    params: { id: '@id' }
                }
            }
        )
]);
